<template>
    <aside role="dialog">
        <div class="content" v-bind="$attrs">
            <section class="image">
                <img src="../../assets/img/cookie.svg" alt="cookie"/>
            </section>
            <img class="close" src="../../assets/img/cross.svg" alt="X" @click="onRefuse"/>
            <section class="title">
                <h2>{{ config.COOKIES_TITLE }}</h2>
            </section>
            <section class="text">
                <p>{{ config.COOKIES_DESCRIPTION }}</p>
            </section>
            <section class="actions">
                <Button :color="config.COLOR_PRIMARY" @click="onAgree">
                    {{ config.COOKIES_AGREE }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" flat @click="onRefuse">
                    {{ config.COOKIES_DENY }}
                </Button>
            </section>
        </div>
    </aside>
</template>
<script>
import { TrackingConsumer, SolutionConsumer } from '../../mixins';

export default {
    name: 'ModalAnalytics',
    mixins: [TrackingConsumer, SolutionConsumer],
    methods: {
        async onAgree () {
            await this.acceptTracking();
            this.$emit('close');
        },
        async onRefuse () {
            await this.refuseTracking();
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

aside {
    @include cover();
    position: fixed;
    z-index: 2;

    > .content {
        @include container(20px);
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        box-shadow: 20px 12px 28px 0 rgba($black, .1);
        background-color: rgba($white, .9);
        backdrop-filter: blur(4px);

        > .close {
            @include square(32px);
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
        }

        > section {
            text-align: center;

            &.image {
                @include square(100px);
                justify-self: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 10px;
                margin-top: -50px - 20px;
                /* Avoids overlapping opacity visual issue */
                background-image: linear-gradient(
                    rgba($white, .9) 0 50%,
                    transparent 50% 100%
                );
                border-radius: 50%;
                z-index: 0;
            }

            &.actions {
                @include flex-vertical();
                align-items: center;

                > button:first-child {
                    margin-bottom: 20px;
                }

                > a {
                    @include a-reset();
                    cursor: pointer;
                }
            }
        }
    }

}
</style>
